<template>
    <div class="CompanyProfile_wrap" :key="isConnect">
        <el-page-header @back="$core.goBack" ></el-page-header>
        <div class="banner"></div>
        <div class="content_wrap" v-if="isConnect == 0">
            <div class="content_title">
                麦思多维简介
            </div>
            <div class="content_text">
                成立于2016年，是一家专注于为教育行业提供整体解决方案的科技公司，以创新技术研发和应用为核心，聚焦数据学、人工智能、虚拟仿真技术在教育行业的综合应用，与多所985、211高校及行业领军企业建立战略合作关系,在教育领域拥有丰富项目案例。
            </div>
            <div class="content_title">
                解决方案体系
            </div>
            <div class="content_text">
                依托麦思多维科技公司多元的产品、丰富的案例以及海量的数据，开放合作、洞察行业动态，推动科技创新与发展、实现业界与院校、理论与实践相融合的持续发展。
            </div>
            <div class="img_wrap">
                <img src="../../assets/img/profileImg.png" alt="">
            </div>
            
            <div class="content_title">
                产品资源服务
            </div>
            <div class="content_two_title">
                智慧教学
            </div>
            <div class="content_text">
                以提供综合解决方案为核心，强调跨专业跨领域创新应用，融合数据科学、人工智能、VR/AR/MR、5G等高新技术与教学实践，解决高校与职业院校教学实训中的实际问题,为高校与职业院校提供金融、财经、汽车、人工智能、医学、思政等专业领域的顶层设计规划、教学实训基地建设、专业技能实训体系构建、教学实训资源建设等服务。
            </div>
            <div class="content_two_title">
                数据科学
            </div>
            <div class="content_text">
                强调数据科学在教育领域的综合应用，与多所高校及行业企业展开合作，以MSData数据科学平台为基础，提供金融财经与产业数据应用、数据科学教学实训体系、专业数据定制等教学与科研应用服务;结合人工智能技术发展，开展编程实训、数据技能、课程学习、证书培训、技能大赛等项目合作。
            </div>
            <div class="content_two_title">
                课程资源
            </div>
            <div class="content_text">
                创新融合教育学、心理学、课程论与智慧教学技术，为学校提供课程建设服务，包括课程整体策划、课程大纲与内容编写、AR立体教材打造、教学实训软件定制、教辅资源（教案、课件、微课、案例、任务工单、习题库、试题集等)制作;立足研究分析成果，为学校提供虚拟仿真项目建设、各级精品课程建设、国家规划教材建设等服务。
            </div>
            <div class="content_two_title">
                智库合作
            </div>
            <div class="content_text">
                创新校企合作理念和方式,融汇教育院校、行业企业、研究机构专家资源，为院校提供各类咨询、培训服务。包括国家级省巿级教育项目申报指导、院校专业(群)重组提升指导、师资队伍定制培训等。
            </div>
            
        </div>
        <div class="content_wrap" v-else>
            <div class="content_title">
                联系我们
            </div>
            <div class="connect_wrap">
                <div> <span>联系电话：</span> 028-85083171 </div>
                <div> <span>电子邮箱：</span> msdw@maxsdsp.com</div>
                <div> <span>联系人：&nbsp;&nbsp;&nbsp;&nbsp;</span> 叶女士</div>
            </div>
            <div class="map_wrap flex-between">
                <div class="map_one">
                    <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
                    <!--缩放-->
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                    <!--定位-->
                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
                    <!--点-->
                    <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
                            <!--提示信息-->
                            <bm-info-window :show="map.show">
                                <h4>成都麦思多维科技有限公司</h4>
                                <span>四川省成都市武侯区领事馆路7号保利中心南塔1701室</span>
                            </bm-info-window>
                        </bm-marker>
                    </baidu-map>
                </div>
                <div class="map_one">
                 <baidu-map class="map" :center="mapTwo.center" :zoom="mapTwo.zoom" @ready="handler">
                            <!--缩放-->
                            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                            <!--定位-->
                            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
                            <!--点-->
                            <bm-marker :position="mapTwo.center" :dragging="mapTwo.dragging" animation="BMAP_ANIMATION_DROP">
                                <!--提示信息-->
                                <bm-info-window :show="mapTwo.show">
                                    <h4>成都麦思多维科技有限公司(重庆分部)</h4>
                                    <span>重庆市渝北区星光大道62号海王星科技大厦D区818号</span>
                                </bm-info-window>
                            </bm-marker>
                    </baidu-map>
                </div>
            </div>
            <div class="apply_wrap">
                <div class="apply_title">MaxSwell相关内容使用申请表</div>
                <div>
                    <el-form :model="applyInfo" label-position="right"  label-width="120px">
                        <el-form-item label="姓名:" >
                            <el-input v-model="applyInfo.name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话:" >
                            <el-input v-model="applyInfo.projectName" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="单位:" >
                            <el-input v-model="applyInfo.company" placeholder="请输入单位"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱:" >
                            <el-input v-model="applyInfo.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="意向合作内容:" >
                            <el-input type="textarea" :autosize="{ minRows:4 }" v-model="applyInfo.projectBoss" placeholder="请输入意向合作内容"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <el-button type="primary" style="width:20%" @click="commitApply">提&nbsp;&nbsp;交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isConnect:this.$route.query.isConnect,
            applyInfo:{
                name:'',
                company:'',
                email:'',
                projectName:'',
                projectBoss:''
            },
            map:{
                center: {lng: 104.0761000000, lat: 30.6303020000},
                zoom: 15,
                show: true,
                dragging: true
            },
            mapTwo:{
                center: {lng: 106.5170620000, lat: 29.6198470000},
                zoom: 15,
                show: true,
                dragging: true
            },
        };
    },
    mounted(){
        
    },

    updated(){

    },

    methods:{
        //提交申请表
        commitApply(){
            this.$message.success('申请表提交成功')
        },

        handler ({BMap, map}) {
            let me = this;
            // 鼠标缩放
            map.enableScrollWheelZoom(true);
            // 点击事件获取经纬度
            map.addEventListener('click', function (e) {})
        }
    }
}
</script>

<style lang="scss" scoped>
.apply_wrap{
    box-sizing: border-box;
    margin: 30px 0px;
    padding: 20px 30%;
    background: #FCFCFC;
    text-align: center;
    .apply_title{
        color:#5277F7;
        font-size: 28px;
        margin: 30px 0px;
        font-weight: 600;
        
    }

}
.connect_wrap{
    padding: 20px 0px 20px 40px;
    line-height: 2;
    span{
        font-weight: 600;
    }
}
.img_wrap{
    width: 100%;
    text-align: center;
        img{
        width: 80%;
    }
}

.content_wrap{
    padding: 30px 270px 200px 270px;
    .content_title{
        margin:40px 0px;
        color: #5277F7;
        font-size: 25px;
        font-weight: 600;
    }
    .content_text{
        font-size: 18px;
        color: #090909;
        line-height: 1.5;
        text-indent: 2rem;
        opacity: 0.8;
    }
    .content_two_title{
        color: #090909;
        font-size: 20px;
        font-weight: 600;
        opacity: 0.8;
        margin: 20px 0px;
    }
    img{
        margin: 10px 0px;
    }
    .map_wrap{
        height: 400px;
        margin: 30px 150px;
        .map_one{
            width: 40%;
            height: 100%;
            border-radius: 10px;
            overflow: hidden;
            span{
                font-size: 12px;
            }
            .map{
                width: 100%;
                height: 100%;
            }
        }
        
    }
}
.CompanyProfile_wrap{
    width: 100%;
    .banner{
        height: 366px;
        background: url('../../assets/img/profileBanner.png') 0 0/100% 100% no-repeat;
    }
    
}
</style>